<template>
  <div id="withDraw">
    <div class="content_box">
      <AuthenticationNote />
      <div class="inner">
        <global-title :title="$t('menu.withdrawFunds')"></global-title>
        <PendingAction v-if="isPoiEditable || isPoaEditable" :isShowPoaNotice="idPass && isPoaEditable" />
        <Notification v-else-if="isPoiUnderReview || isPoaUnderReview" :id="isPoiUnderReview" :poa="isPoaUnderReview" />
      </div>
      <div class="inner" v-if="showWithdraw">
        <div class="withDraw_form" v-show="formFlag">
          <div class="box box_card_top">
            <TopLeft
              ref="topLeft"
              :paymentAuthConfig="paymentAuthConfig"
              :socialTrading="socialTrading"
              :checkSocialTradingFollower="checkSocialTradingFollower"
              @setForm="getForm"
              @setTopForm="getTopForm"
              @reset="reset"
            ></TopLeft>
            <div v-if="showRight">
              <hr class="vl" />
            </div>
            <TopRight
              ref="topRight"
              :withdrawForm="withdrawForm"
              :socialTradingPerformanceFee="socialTrading.performanceFee"
              :topForm="topForm"
              :reset.sync="resetForm"
              :showRight="showRight"
              :disableOtherMeThod="disableOtherMeThod"
              :disableSecondMethod="disableSecondMethod"
              @setSecondWithdraw="getSecondWithdraw"
              :disabled="disableOtherMeThod"
              :paymentAuthConfig="paymentAuthConfig"
              @setWithdraw="getWithdraw"
            ></TopRight>
          </div>

          <div v-if="!resetForm">
            <CcMethod
              ref="ccMethod"
              v-if="topForm.showCC"
              @onDisableMethod="onDisableMethod"
              :withdrawForm="withdrawForm"
              :topForm="topForm"
              :isShowOtherPayment="topForm.showOtherPayment"
            ></CcMethod>

            <!--secondary Method -->
            <OtherMethod
              ref="secondMethod"
              v-if="(topForm.showLBT && chooseSecondWithdraw.chooseWithdrawalType && !isFreeze) || disableMethod"
              :topForm="topForm"
              :withdrawForm="withdrawForm"
              :bankList="bankList"
              :disabled="disableSecondMethod"
              :chooseWithdraw="chooseSecondWithdraw"
              :withdrawalPayment="$store.state.cps.secondaryWithdrawalPayment"
            ></OtherMethod>

            <!--tertiary Method -->
            <OtherMethod
              ref="otherMethod"
              v-if="(topForm.showOtherPayment && chooseWithdraw.chooseWithdrawalType && !isFreeze) || disableMethod"
              :topForm="topForm"
              :withdrawForm="withdrawForm"
              :bankList="bankList"
              :disabled="disableOtherMeThod"
              :chooseWithdraw="chooseWithdraw"
              :withdrawalPayment="$store.state.cps.withdrawalPayment"
            ></OtherMethod>
          </div>
          <div class="box" v-if="showSubmit">
            <!-- <div class="box-card-verification">
              <VerificationCode
                ref="verificationCode"
                namespace="CP_WITHDRAW"
                v-if="isCryptoPayments || is2FAPayments"
              ></VerificationCode>
            </div> -->
            <div class="box_card_submit">
              <el-checkbox v-model="checkStatus" data-testid="checkbox">
                <i18n path="withdraw.default.agreePolicy">
                  <template v-slot:link>
                    <a @click="disclaimerVisible = true" data-testid="withdrawPolicy"
                      >&nbsp;{{ $t('withdraw.default.withdrawPolicy') }}</a
                    >
                  </template>
                </i18n>
              </el-checkbox>
              <div>
                <el-button
                  class="blue_button"
                  @click="isWelcomeBonusUser ? isWelcomeBonusAccount() : submitForm()"
                  :disabled="!checkStatus"
                  :loading="loading"
                  data-testid="submit"
                  >{{ $t('withdraw.default.submitYourWithdrawal') }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <Result v-if="successFlag" :fail="result.fail">{{ result.message }}</Result>
        <vDialog :show.sync="dialog.show" :text="dialog.text">
          <template v-slot:btn>
            <div class="form_button">
              <el-button
                class="blue_button"
                v-if="dialog.method === 'amountFee'"
                @click="confirmAmountFee"
                data-testid="confirmAmountFee"
                >{{ $t('common.button.confirm') }}</el-button
              >
              <el-button class="white_button" @click="dialog.show = false" data-testid="cancel">{{
                $t('common.button.cancel')
              }}</el-button>
            </div>
          </template>
        </vDialog>
        <vDialog :show.sync="positionDialog.show" :text="positionDialog.text">
          <template v-slot:btn>
            <el-button
              class="blue_button"
              v-if="positionDialog.showConfirm"
              @click="equityConfirm(submitWithdrawWrapper)"
              data-testid="confirm"
              >{{ $t('common.button.confirm') }}</el-button
            >
            <el-button
              class="white_button"
              v-if="positionDialog.showCancel"
              @click="hidePositionDialog"
              data-testid="cancel"
              >{{ $t('common.button.cancel') }}</el-button
            >
          </template>
        </vDialog>
        <disclaimerDialog :visible.sync="disclaimerVisible">
          <div class="info_box">
            <ul dir="ltr" v-html="$t('withdraw.default.disclaimer', { platform: $config.info.fullName })"></ul>
          </div>
        </disclaimerDialog>
        <redepositBonusWithdrawAlert
          :visible.sync="showWithdrawalDialog"
          :message="$t('promotion.welcomeBonus.dialog.withdraw.desc')"
          :confirmText="$t('promotion.welcomeBonus.dialog.withdraw.confirm')"
          @confirm="submitForm"
        >
        </redepositBonusWithdrawAlert>
      </div>

      <el-dialog
        :visible="confirmationVisibility"
        id="ConfirmationComponent"
        :close-on-click-modal="false"
        @close="cancelChanges"
      >
        <div class="dialog-body">
          <ConfirmationComponent
            :showDynamicComponent="dynamicParameters"
            @confirm="confirmChanges"
            @changeVisible="cancelChanges"
          ></ConfirmationComponent>
        </div>
      </el-dialog>
      <VerificationDialog
        ref="verification"
        :dialogVisible.sync="verificationVisibility"
        :usedAuthTypes="paymentAuthConfig.authType"
        action="withdraw"
        @changeVisible="updateVerificationVisible"
        @confirm="confirmVerification"
      ></VerificationDialog>

      <CampaignWithdrawalModal
        :campaignWithdrawalModalVisible.sync="campaignWithdrawalModalVisible"
        :mt4account="withdrawForm.account"
        @proceed="withdrawConfirmProceed"
        :isNotice="false"
      >
      </CampaignWithdrawalModal>

      <!-- after change password -->

      <el-dialog
        class="withdrawal_freeze_dialog"
        :title="$t('security.withdrawalFreeze.header')"
        :visible.sync="visible"
        width="480px"
        center
        :show-close="true"
      >
        <div class="text-sm" v-if="fromFunctionCode === 'updateUserLogin'">
          {{ $t('security.withdrawalFreeze.userLoginDesc', { days: limitDayNumber, hours: lastHours }) }}
        </div>
        <div class="text-sm" v-if="fromFunctionCode === 'updatePassword'">
          {{ $t('security.withdrawalFreeze.passDesc', { days: limitDayNumber, hours: lastHours }) }}
        </div>
        <div class="text-sm" v-if="fromFunctionCode === 'changeAuthenticator'">
          {{ $t('security.withdrawalFreeze.limitSecurityAuthenticator', { days: limitDayNumber, hours: lastHours }) }}
        </div>
        <div class="text-center">
          <PrimaryButton
            padding="px-10"
            height="h-12"
            width="min-w-42"
            :onClick="closeLimitDialog"
            class="dialog-btn"
            bgColor="!bg-blueG1"
            >{{ $t('security.understand') }}
          </PrimaryButton>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import GlobalTitle from '@/components/global/title';
import PendingAction from '@/components/home/PendingAction';
import Notification from '@/components/home/Notification';
import {
  apiCheckSocialTradingFollowerResult,
  apiApplyWithdrawal_cp_batch,
  apiCampaignInfo,
  apiGetMultiFactorAuth,
  apiGetSecurityInfo
} from '@/resource';
import TopLeft from './TopLeft';
import TopRight from './TopRight';
import CcMethod from './CcMethod';
import OtherMethod from './OtherMethod';
// import VerificationCode from './VerificationCode';
import vDialog from '@/components/vDialog';
import disclaimerDialog from '@/components/home/vDialog';
import redepositBonusWithdrawAlert from '@/components/cnDepositBonus/reDepositBonus/PopOut';
import Result from '@/components/Result';
import mixin from '@/mixins';
import checkPositionMixin from '@/mixins/page/tools/checkPosition';
import uscMixin from '@/mixins/usc';
import promotionMixin from '@/mixins/promotion';
import { mapGetters } from 'vuex';
import CampaignWithdrawalModal from './CampaignWithdrawalModal';
import WithdrawalFreezeDialog from '@/components/withdraw/WithdrawalFreezeDialog.vue';
import { countryCodeEnum } from '@/constants/country';
import AuthenticationNote from '@/components/security/AuthenticationNote';
import { mapVerifiedAuth, mapReverifiedBody } from '@/components/security/Security.js';
import ConfirmationComponent from '@/components/security/ConfirmationComponent.vue';
import VerificationDialog from '@/components/security/VerificationDialog.vue';
import PrimaryButton from '@/components/buttons/primaryButton/PrimaryButton.vue';
import { sensorsWithdrawalStep1PageView } from '@/util/sensorsdata/util';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';
import store from '@/store/index';

export default {
  name: 'withdrawFunds',
  components: {
    TopLeft,
    TopRight,
    CcMethod,
    OtherMethod,
    PendingAction,
    Notification,
    vDialog,
    disclaimerDialog,
    Result,
    redepositBonusWithdrawAlert,
    // VerificationCode,
    CampaignWithdrawalModal,
    WithdrawalFreezeDialog,
    GlobalTitle,
    AuthenticationNote,
    ConfirmationComponent,
    VerificationDialog,
    PrimaryButton
  },
  mixins: [checkPositionMixin, mixin, uscMixin, promotionMixin],
  data() {
    return {
      topForm: {
        creditCardBalances: [],
        showCC: false,
        showOtherPayment: false,
        totalCcBalance: 0,
        userCountryCode: ''
      },
      result: {
        message: this.$t('withdraw.default.success'),
        fail: false
      },
      dialog: { show: false, text: '', method: '' },
      disclaimerVisible: false,
      withdrawForm: {
        formAccount: '',
        amount: 0,
        withdrawalType: ''
      },
      socialTrading: { isSuccess: false, hasFollow: false, performanceFee: 0, followerResultIds: [] },
      chooseSecondWithdraw: {},
      chooseWithdraw: {},
      AMLAlert: { units: 100, charge: 20 },
      formFlag: true,
      successFlag: false,
      amountFeeFlag: false, //手续费
      bankList: {},
      resetForm: true,
      otherType: null,
      lbtType: null,
      disableMethod: false,
      showRight: false,
      checkStatus: true,
      showWithdrawalDialog: false,
      accountInfo: null,
      paymentAuthConfig: {},
      confirmationVisibility: false,
      dynamicParameters: null,
      verificationVisibility: false,
      apiRequest: null,
      campaignWithdrawalModalVisible: false,
      clickedProceed: false,
      visible: false,
      fromFunctionCode: '',
      limitDayNumber: '',
      lastHours: '',
      loading: false
    };
  },
  computed: {
    showWithdraw() {
      return this.idPass && this.poaPass;
    },
    showSubmit() {
      const displayLBT = this.topForm.showLBT;
      const displayOtherPayment = this.topForm.showOtherPayment;

      const LBT_Pass = this.lbtType ? true : false;
      const OtherPayment_Pass = this.otherType ? true : false;

      if (this.resetForm || this.isFreeze) return false;

      if (displayLBT && !displayOtherPayment) {
        return LBT_Pass;
      } else if (!displayLBT && displayOtherPayment) {
        return OtherPayment_Pass;
      } else if (displayLBT && displayOtherPayment) {
        return LBT_Pass && OtherPayment_Pass;
      } else {
        return true;
      }
    },
    isWelcomeBonusUser() {
      return this.$store.state.promotion.eligibleCampaigns.find(c => c.campaignType === 'WELCOME_BONUS');
    },
    isCryptoPayments() {
      if (this.resetForm) return false;
      const cryptoPaymentIdList = [34, 36, 80, 81, 7, 31, 32, 33, 37, 38, 41, 61, 69, 75];
      const currentPaymentId = this.chooseWithdraw?.chooseWithdrawalType?.id;
      return currentPaymentId ? cryptoPaymentIdList.includes(currentPaymentId) : false;
    },
    is2FAPayments() {
      let is2FAPaymentIdList = [];
      // FX-IR (Iran)
      if (this.topForm.userCountryCode === countryCodeEnum.IRAN) {
        is2FAPaymentIdList.push(97);
      }

      const currentPaymentId = this.chooseWithdraw?.chooseWithdrawalType?.id;
      return currentPaymentId ? is2FAPaymentIdList.includes(currentPaymentId) : false;
    },
    toShowCampaignWithdrawalModal() {
      if (this.clickedProceed) return false;

      const isAccountParticipatedTC = this.participatedTC.find(campaign => {
        return (
          campaign.participantAccount?.some(account => account.mt4Account === this.withdrawForm.account) &&
          campaign.withdrawDisqualify === true
        );
      });

      return isAccountParticipatedTC;
    },
    disableOtherMeThod() {
      return this.disableMethod || (this.topForm.showLBT && this.lbtType === null);
    },
    disableSecondMethod() {
      return this.disableMethod;
    },
    ...mapGetters('common', [
      'idPass',
      'poaPass',
      'isPoiUnderReview',
      'isPoaUnderReview',
      'isPoiEditable',
      'isPoaEditable'
    ])
  },
  watch: {
    'topForm.showCC'() {
      this.$store.commit('common/setAuthHeaders', {
        etxId: '',
        eCode: '',
        ptxId: '',
        pCode: '',
        tCode: ''
      });
      if (this.topForm.showCC) {
        //ensure totp is verified
        if (
          this.paymentAuthConfig.paymentChannel?.includes(1) &&
          !this.paymentAuthConfig.authType?.every(item => item.verified) &&
          !this.topForm.showOtherPayment
        ) {
          this.dynamicParameters = {
            title: this.$t('security.verificationTitle'),
            desc: this.$t('security.verificationDesc'),
            cancelButton: null,
            confirmButton: this.$t('common.button.confirm')
          };
          this.confirmationVisibility = true;
        }
      }
    },
    chooseWithdraw() {
      this.$store.commit('common/setAuthHeaders', {
        etxId: '',
        eCode: '',
        ptxId: '',
        pCode: '',
        tCode: ''
      });
      const usedId = this.chooseWithdraw?.chooseWithdrawalType?.id;
      if (
        this.paymentAuthConfig.paymentChannel?.includes(usedId) &&
        !this.paymentAuthConfig.authType?.every(item => item.verified)
      ) {
        this.dynamicParameters = {
          title: this.$t('security.verificationTitle'),
          desc: this.$t('security.verificationDesc'),
          cancelButton: this.$t('common.button.cancel'),
          confirmButton: this.$t('common.button.confirm')
        };
        this.confirmationVisibility = true;
      }
    },
    withdrawForm() {
      this.isFreeze = false;
    },
    'withdrawForm.account'() {
      if (this.withdrawForm.account) {
        this.checkSocialTradingFollower();
      } else {
        this.resetSocialTrading();
      }
    }
  },
  async mounted() {
    sensorsWithdrawalStep1PageView();
    this.$store.commit('common/setAuthHeaders', {
      etxId: '',
      eCode: '',
      ptxId: '',
      pCode: '',
      tCode: ''
    });
    this.$store.dispatch('common/actionPoiAuditStatus');
    this.$store.dispatch('common/actionPoaAuditStatus');

    if (this.isWelcomeBonusUser) this.getWelcomeBonusInfo();
    await this.getAuthInfo();
    await this.getPaymentAuthConfig();
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.payment.isUsePcs) {
      next(vm => {
        vm.$router.go(0);
      });
    } else {
      next();
    }
  },
  methods: {
    confirmChanges() {
      this.$router.push('/securityManagement');
    },
    cancelChanges() {
      this.confirmationVisibility = false;
      this.$refs.topRight.cancelChanges();
    },
    updateVerificationVisible() {
      this.verificationVisibility = false;
    },
    async getAuthInfo() {
      await apiGetSecurityInfo().then(resp => {
        if (resp.data.code == 0) {
          const usedValue = resp.data.data;
          this.$store.commit('common/setCheckedAuthStatus', usedValue.authStatus);
        }
      });
    },
    async getPaymentAuthConfig() {
      await apiGetMultiFactorAuth('withdraw')
        .then(resp => {
          if (resp.data.code == 0) {
            let usedRequiredAuths = this.$store.state.common.requiredAuths;
            usedRequiredAuths['withdraw'] = resp.data.data.authType;
            this.$store.commit('common/setRequiredAuths', usedRequiredAuths);
            this.paymentAuthConfig = {
              authType:
                resp.data.data.authType && resp.data.data.authType.length > 0
                  ? resp.data.data.authType.map(item => {
                      return {
                        type: item,
                        verified: mapVerifiedAuth(item, this.$store.state.common.checkedAuthStatus),
                        authenticated: false
                      };
                    })
                  : [],
              paymentChannel: resp.data.data.paymentChannel ? resp.data.data.paymentChannel : []
            };
          }
        })
        .catch(() => {
          console.log('getPaymentAuthConfig error');
        });
    },
    // fix:ACM-34977 安全验证通过且出金接口报错后 再次重复点击提交出金时安全验证确认按钮无法点击问题
    // 弹窗子组件内部usedObject是通过传入的paymentAuthConfig.authType中的authenticated过滤而来的 过滤后usedObject可能为undefined
    // 若需要再次进行安全验证 则需重置paymentAuthConfig.authType,将authenticated初始化为false
    repeatSubmitWhenSecurityAuthOpen() {
      if (this.paymentAuthConfig.authType && this.paymentAuthConfig.authType.length > 0) {
        this.paymentAuthConfig.authType = this.paymentAuthConfig.authType.map(item => {
          return {
            ...item,
            authenticated: false
          };
        });
      }
    },
    getForm(form) {
      this.withdrawForm = { ...form };
    },
    getTopForm(topForm, countryBankList, showRight) {
      this.topForm = { ...topForm };
      this.bankList = countryBankList;
      this.showRight = showRight;
    },
    getSecondWithdraw(val) {
      this.chooseSecondWithdraw = val;
      this.lbtType = val.withdrawalType;
      if (val.chooseWithdrawalType) {
        this.$refs.topLeft.checkMinLimit(val?.chooseWithdrawalType?.amountLimit, val.withdrawalType);
      }
    },
    getWithdraw(val) {
      this.chooseWithdraw = val;
      this.otherType = val.withdrawalType;
      if (val.chooseWithdrawalType) {
        this.$refs.topLeft.checkMinLimit(val?.chooseWithdrawalType?.amountLimit, val.withdrawalType);
      }
    },
    setSuccess(res) {
      this.formFlag = false;
      this.successFlag = true;
      this.handleErrorCode(res);
    },
    reset(bool) {
      this.resetForm = bool;
      this.checkStatus = true;
    },
    getMethodComponent() {
      return [this.$refs.otherMethod, this.$refs.ccMethod, this.$refs.secondMethod];
    },
    validComponent(otherMethodComponent, ccMethodComponent, secondMethodComponent) {
      return [
        otherMethodComponent ? otherMethodComponent.submitForm() : Promise.resolve(),
        ccMethodComponent ? ccMethodComponent.submitForm() : Promise.resolve(),
        secondMethodComponent ? secondMethodComponent.submitForm() : Promise.resolve()
      ];
    },
    onDisableMethod(bool) {
      this.disableMethod = bool;
    },
    submitForm() {
      if (this.toShowCampaignWithdrawalModal) {
        this.campaignWithdrawalModalVisible = true;
        return;
      }
      // 父組件驗證
      const [getOtherMethodComponent, getCcMethodComponent, getSecondMethodComponent] = this.getMethodComponent();
      const [verifyOtherMethod, verifyCcMethod, verifySecondMethod] = this.validComponent(
        getOtherMethodComponent,
        getCcMethodComponent,
        getSecondMethodComponent
      );

      let validParam = getCcMethodComponent
        ? [verifyOtherMethod, ...verifyCcMethod, verifySecondMethod]
        : [verifyOtherMethod, verifyCcMethod, verifySecondMethod];

      Promise.all(validParam).then(valid => {
        if (valid) {
          this.checkPosition(
            this.withdrawForm.account,
            this.withdrawForm.amount,
            'withdraw',
            this.submitWithdrawWrapper
          );
        } else return false;
      });
    },
    withdrawConfirmProceed(val) {
      if (val == true) {
        this.clickedProceed = true;
        this.submitForm();
      }
    },

    handleErrorCode(code) {
      if (code === 300) {
        // for credit card
        this.result.fail = true;
        this.result.message = this.$t('withdraw.default.ccFail', {
          email: this.GLOBAL_CONTACT_EMAIL
        });
      }
    },
    confirmAmountFee() {
      this.dialog.show = false;
      this.submitWithdraw();
    },
    checkWithdrawlAmount() {
      //close amount fee
      const isChargeFee = false;
      if (!isChargeFee) {
        this.amountFeeFlag = true;
        return;
      }
      const units = this.checkIsUSC(this.withdrawForm.currency)
        ? this.convertUSDToUSC(this.AMLAlert.units)
        : this.AMLAlert.units;
      const charge = this.checkIsUSC(this.withdrawForm.currency)
        ? this.convertUSDToUSC(this.AMLAlert.charge)
        : this.AMLAlert.charge;

      if (this.withdrawForm.amount < units && this.withdrawForm.amount !== 0 && this.otherType === 4) {
        this.dialog = {
          show: true,
          text: this.$t('withdraw.default.withdrawlFeeAlert', {
            units: units,
            charge: charge
          }),
          method: 'amountFee'
        };
      } else {
        this.amountFeeFlag = true;
      }
    },
    checkSocialTradingFollower() {
      this.resetSocialTrading();
      apiCheckSocialTradingFollowerResult({
        mtAccount: this.withdrawForm.account
      }).then(resp => {
        if (resp.data.code === 0 && resp.data.data) {
          this.socialTrading.isSuccess = true;
          const responseData = resp.data.data;
          if (responseData.hasFollow) {
            this.socialTrading.hasFollow = responseData.hasFollow;
            this.socialTrading.performanceFee = responseData.outstandingPerformanceFee ?? 0;
            this.socialTrading.followerResultIds = responseData.followerResultIds ?? [];
          }
        }
      });
    },
    resetSocialTrading() {
      this.socialTrading.isSuccess = false;
      this.socialTrading.hasFollow = false;
      this.socialTrading.performanceFee = 0;
      this.socialTrading.followerResultIds = [];
    },
    submitWithdrawWrapper() {
      this.checkWithdrawlAmount();
      if (this.amountFeeFlag) {
        this.submitWithdraw();
      }
    },
    confirmVerification() {
      this.verificationVisibility = false;
      this.submitApi();
    },
    postApiApplyWithdrawal_cp() {
      const [getOtherMethodComponent, getCcMethodComponent, getSecondMethodComponent] = this.getMethodComponent();
      let apiData = [];

      if (this.topForm.showCC) {
        const topFromData = { ...getCcMethodComponent.getFormDataOfChild() };
        if (topFromData.creditCardWithdrawalRequests.length > 0) {
          apiData.push({
            ...getCcMethodComponent.getFormDataOfChild(),
            followerResultIds: this.socialTrading.followerResultIds
          });
        }
      }
      if (this.topForm.showLBT) apiData.push({ ...getSecondMethodComponent.getFormDataOfChild() });
      if (this.topForm.showOtherPayment)
        apiData.push({
          ...getOtherMethodComponent.getFormDataOfChild(),
          followerResultIds: this.socialTrading.followerResultIds
        });
      return apiData;
    },
    submitWithdraw() {
      //get request
      this.apiRequest = this.postApiApplyWithdrawal_cp();
      // do authentication first
      const needAuth = this.apiRequest.some(item =>
        this.paymentAuthConfig?.paymentChannel?.includes(item.withdrawalType)
      );
      if (needAuth && this.paymentAuthConfig.authType?.length > 0) {
        this.verificationVisibility = true;
      } else {
        this.submitApi();
      }
    },
    submitApi() {
      this.loading = true;
      apiApplyWithdrawal_cp_batch(this.apiRequest, this.token)
        .then(async result => {
          this.repeatSubmitWhenSecurityAuthOpen(); // fix:出金报错后 再次点击提交出金时安全验证确认按钮无法点击问题
          if (result && result.data.code == 585) {
            // re-calling anti-reuse token
            this.fetchToken()
              .then(resp => {
                this.loading = false;
              })
              .catch(resp => {
                this.loading = false;
                if (result.data.code !== 562) {
                  this.errorMessage(this.$t('deposit.default.failed'));
                }
              });
          } else if (result && (result.data.code == 638 || result.data.code == 639 || result.data.code == 637)) {
            // 638为修改账号引发的限制   639为修改密码引发的限制 637为修改2fa验证器引发的限制
            this.fromFunctionCode =
              result.data.code === 638
                ? 'updateUserLogin'
                : result.data.code === 637
                ? 'changeAuthenticator'
                : 'updatePassword';
            this.limitDayNumber = 'T + ' + result.data.data.limitDayNumber;
            this.lastHours = result.data.data.lastHours;
            this.visible = true;
            // re-calling anti-reuse token
            this.fetchToken()
              .then(resp => {
                this.loading = false;
              })
              .catch(resp => {
                this.loading = false;
                if (result.data.code !== 562) {
                  this.errorMessage(this.$t('deposit.default.failed'));
                }
              });
            await this.getPaymentAuthConfig();
          } else if (result && (result.data.code == 0 || result.data.code == 300)) {
            this.setSuccess(result.data.code);
          } else if (result.data.code === 1201 || result.data.code == 1202) {
            // re-calling anti-reuse token
            this.fetchToken()
              .then(resp => {
                this.loading = false;
              })
              .catch(resp => {
                this.loading = false;
                if (result.data.code !== 562) {
                  this.errorMessage(this.$t('deposit.default.failed'));
                }
              });
            await this.getPaymentAuthConfig();
            this.paymentAuthConfig.authType = mapReverifiedBody('withdraw', result);
            const allVerified = this.paymentAuthConfig.authType.every(item => item.verified == true);
            if (!allVerified) {
              if (
                this.paymentAuthConfig.paymentChannel?.includes(1) &&
                this.apiRequest.filter(item => item.withdrawalType == 1).length > 0
              ) {
                this.dynamicParameters = {
                  title: this.$t('security.verificationTitle'),
                  desc: this.$t('security.verificationDesc'),
                  cancelButton: null,
                  confirmButton: this.$t('common.button.confirm')
                };
              } else {
                this.dynamicParameters = {
                  title: this.$t('security.verificationTitle'),
                  desc: this.$t('security.verificationDesc'),
                  cancelButton: this.$t('common.button.cancel'),
                  confirmButton: this.$t('common.button.confirm')
                };
              }
              this.confirmationVisibility = true;
            } else {
              this.verificationVisibility = true;
            }
          } else {
            // re-calling anti-reuse token
            this.fetchToken()
              .then(resp => {
                this.loading = false;
              })
              .catch(resp => {
                this.loading = false;
                if (result.data.code !== 562) {
                  this.errorMessage(this.$t('deposit.default.failed'));
                }
              });
          }
        })
        .catch(err => {
          this.$message({
            message: this.$t('withdraw.default.failed'),
            type: 'error'
          });
          this.repeatSubmitWhenSecurityAuthOpen(); // fix:出金报错后 再次点击提交出金时安全验证确认按钮无法点击问题
        });
    },
    async closeLimitDialog() {
      this.visible = false;
      // re-calling anti-reuse token
      this.fetchToken()
        .then(resp => {
          this.loading = false;
        })
        .catch(resp => {
          this.loading = false;
          if (result.data.code !== 562) {
            this.errorMessage(this.$t('deposit.default.failed'));
          }
        });
    },
    isWelcomeBonusAccount() {
      let currentForm = JSON.parse(this.withdrawForm.formAccount);
      let isEligibleStatus =
        this.accountInfo.status === 'CV' ||
        this.accountInfo.status == 'WD' ||
        this.accountInfo.status == 'B' ||
        this.accountInfo.status == 'OO';
      let isEligibleWelcomeBonus = this.accountInfo.mt4Account === currentForm.login && !isEligibleStatus;
      if (isEligibleWelcomeBonus) this.showWithdrawalDialog = true;
      else this.submitForm();
    },
    getWelcomeBonusInfo() {
      apiCampaignInfo(25)
        .then(resp => {
          if (resp.data.code === 0) {
            this.accountInfo = resp.data.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/withdraw.scss';

#ConfirmationComponent {
  .footer_body {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  /deep/ .el-button {
    width: 100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 1;
    height: 40px;
  }

  /deep/ .el-dialog {
    margin-top: 0vh !important;
    border-radius: 12px;
    padding: 38px;
    height: auto;
    max-width: 460px;
    .footer_body {
      display: flex;
      flex-direction: row;
      gap: 20px;
    }
    .el-dialog__body {
      text-align: center;
    }

    .el-dialog__headerbtn {
      display: none;
    }
  }

  /deep/ .el-dialog__header {
    padding: 0px;
  }

  /deep/ .el-dialog__body {
    font-size: 14px;
    font-weight: 400;
    padding: 0px;
    padding-bottom: 0px;

    .el-dialog__body {
      text-align: center;
    }

    .title {
      padding-bottom: 20px;
      color: #000a2d;
    }

    .body {
      padding-bottom: 20px;
    }
  }

  /deep/ .el-dialog__footer {
    padding: 0px;
  }
}
.withdrawal_freeze_dialog {
  /deep/ {
    .el-dialog__header {
      padding: 20px;
      text-align: center;
      color: #000a2d;
      .el-dialog__title {
        font-size: 20px;
        font-weight: 600;
      }
      .el-dialog__headerbtn {
        top: 20px;
        right: 20px;
        .el-dialog__close {
          font-size: 14px;
        }
      }
    }
  }
  /deep/.el-dialog {
    width: 480px;
    max-width: 497px;
    margin-top: 0vh !important;
    .el-dialog__body {
      text-align: center;
      word-break: normal;
      .text-sm {
        color: #606266;
        line-height: 1.5;
        margin-top: 12px;
      }
      .text-center {
        margin-top: 20px;
      }
    }
  }
}
@media (max-width: 550px) {
  .withdrawal_freeze_dialog {
    /deep/.el-dialog {
      width: 300px !important;
    }
    /deep/ .el-dialog .el-dialog__body {
      font-size: 14px;
    }
  }
}
</style>
